module.exports = __webpack_public_path__ + "static/media/bubble-active-5.13a8a4d1.svg";